// @ts-nocheck
import React from 'react';
import icons from '../../../../constants/icons';
import ImageFromApi from '../../../common/ImageFromApi';

export interface PlatformRowProps {
  game: Record<string, unknown>;
  style: React.CSSProperties;
}

function PlatformRow({ game, style }: PlatformRowProps) {
  return (
    <div className="grid-empty" style={style}>
      {game.isSKU && (
        <>
          <ImageFromApi
            imageId={game.platformImageId}
            fallbackIcon={icons.PLATFORM}
            colourHex={game.platformColourHex}
          ></ImageFromApi>
          {game.platform}
        </>
      )}
    </div>
  );
}

export default PlatformRow;
